<template>
	<div>
		<div class="list_top_box">
			<div class="left_option">
				<span>Period Type: </span>
				<select class="tbl_select ssm3_int mgr_10" v-model="unit">
					<option value="DAY">IN MONTH</option>
					<option value="MONTH">IN YEAR</option>
				</select>

				<span>Year: </span>
				<select class="tbl_select sssm_int mgr_10" v-model="year">
					<option v-for="(i, index) in 20" :key="i" :value="thisYear - index">{{ thisYear - index }}</option>
				</select>

				<span>Month: </span>
				<select :disabled="unit === 'MONTH'" class="tbl_select sssm_int mgr_10" v-model="month">
					<option v-for="i in 12" :key="i" :value="i">{{ i }}</option>
				</select>

				<a href="javascript:;" class="search_bt" @click="chartKey++">Search</a>
			</div>
		</div>
		<div style="overflow: hidden; min-height: 370px; max-height: 370px; position: relative;">
			<AccountReceivedGraph :unit="unit" :year="year" :month="month" :key="chartKey" @emitSumData="sum_data = $event" />
		</div>
		<p class="al_center">
			<b class="mgr_10" v-for="(prop, index) in Object.keys(sum_data)" :key="index">{{ prop }}: ${{ sum_data[prop] | toCurrency }}</b>
		</p>
	</div>
</template>

<script>
import AccountReceivedGraph from '@/views/statistics/accountReceived/AccountReceivedGraph.vue';
export default {
	data: () => ({
		unit: null,
		year: 0,
		thisYear: 0,
		month: 0,
		chartKey: 0,

		sum_data: {},
	}),
	components: {
		AccountReceivedGraph,
	},
	methods: {
		async init() {
			let today = new Date();
			this.unit = 'DAY';
			this.thisYear = today.getFullYear();
			this.year = today.getFullYear();
			this.month = today.getMonth() + 1;
		},
	},
	created() {
		this.init();
	},
};
</script>

<style></style>
